import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { atom_tourState } from "@app/shared/state/tour.atom";
import { passiveCollector } from "@app/shared/services/passive-data/passive-data-collector";

export function InputSection({ onSendMessage }: { onSendMessage: (message: string) => void }) {
  const [inputValue, setInputValue] = useState("");
  const { t } = useTranslation();
  const tourState = useRecoilValue(atom_tourState);     
  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    passiveCollector.trackChatOpened();
    onSendMessage(inputValue);
    setInputValue("");
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: "auto" }}>
      <Box 
        sx={{ 
          display: "flex", 
          alignItems: "flex-start", 
          gap: 2, 
          boxShadow: "0 0 10px 0 rgba(0,0,0,0.10)", 
          border: "1px solid #C0C0C0",
          bgcolor: "white", 
          px: 2, 
          py: 1, 
          borderRadius: 2,
          direction: "ltr"
        }}
      >
        <IconButton
          disabled={inputValue.length === 0}
          type="submit"
          sx={{
            width: "45px",
            height: "45px",
            bgcolor: `${tourState?.config?.['titleColor'] || '#D0552E'}`,
            borderRadius: "15px",
            marginRight: "auto",
            color: "white",
            "&:hover": {
              bgcolor: `${tourState?.config?.['titleColor'] || '#D0552E'}`
            }
          }}
          aria-label={t("Send message") as string}
        >
          <ArrowUpwardIcon />
        </IconButton>
        <TextField
          value={inputValue}
          onChange={(e) => {
            if (e.target.value.length <= 120) {
              setInputValue(e.target.value);
            }
          }}
          placeholder={t("Looking for a culinary tour with top") as string}
          fullWidth
          variant="standard"
          multiline
          autoComplete="nope"
          inputProps={{
            maxLength: 120,
            autoComplete: 'nope',
          }}
          InputProps={{
            disableUnderline: true,
            sx: {
              fontSize: "16px",
              color: "#959290",
              "& input": {
                fontSize: "16px !important",
                transform: "scale(1)",
                transformOrigin: "0 0"
              },
              "& textarea": {
                fontSize: "16px !important",
                transform: "scale(1)",
                transformOrigin: "0 0"
              }
            }
          }}
        />
      </Box>
    </Box>
  );
}